module.exports = __webpack_public_path__ + "img/button-md-true@3x.f6ec493.png";